import { render, staticRenderFns } from "./Frames.vue?vue&type=template&id=445d8b3d&"
import script from "./Frames.vue?vue&type=script&lang=js&"
export * from "./Frames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports